import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import MyRouter from './router';

ReactDOM.render(
  <MyRouter />,
  document.getElementById('root')
);